<template>
  <ProjectNotFound v-if="not_found"/>
  <div v-else class="grid-container">
    <div class="question-display">
      <h3>{{this.project.title}}</h3>
      <h3>{{this.question}}</h3>
    </div>
    <div class="add-event">
      <AddEventBlock v-on:add-event="addEventBlock" v-on:error-alert="logError" :field_names="field_names"/>
    </div>
    <div class="event-blocks">
      <Events v-bind:event_items="event_items" v-on:date-change="dateChange" v-on:delete-event="deleteEvent" v-on:error-alert="logError" v-on:name-change="eventNameChange" :field_names="field_names"/>
    </div>
    <div class="question">
      <label for="question_in">What question can we answer using these events?</label>
      <input type="text" v-model="question" id="question_in" name="question_in" placeholder="Type your question..."/>
    </div>
    <div class="content">
      <TextDisplay v-if="text" :image="text_image" :title="text_title" />
      <TimelineVis v-else :event_items="event_items" :key="componentKey"/>
    </div>
    <div class="to-timeline" v-if="text">
      <input type="submit" v-on:click="toTimeline" value="To Timeline" class="button"/>
    </div>
    <div class="to-text" v-else>
      <input type="submit" v-on:click="toText" value="To Text" class="button"/>
    </div>
  </div>
</template>

<script>
import AddEventBlock from '@/components/AddEventBlock.vue'
import Events from '@/components/Events.vue'
import TimelineVis from '@/components/TimelineVis.vue'
import TextDisplay from '@/components/TextDisplay.vue'
import ProjectNotFound from '@/components/ProjectNotFound.vue'

export default {
  name: 'StudentView',
  components: {
    TimelineVis,
    Events,
    AddEventBlock,
    TextDisplay,
    ProjectNotFound
  },
  data() {
    return {
      not_found: false,
      text: false,
      project: {},
      event_items: [],
      componentKey: 0,
      question: "",
      field_names: [],
      text_image: "",
      text_title: ""
    }
  },
  methods: {
    async getProject(uuid) {
      let result;

      if (uuid == "01") {
        result = {
          success: true,
          project: {
          guiding_question: "",
          text_image: "",
          text_title: "",
          field_names: [],
        }
      };
      } else {
        let url = 'api/project/' + uuid;

        let res = await fetch(url, {
          method: 'GET'
        });

        result = (await res.json());
      }

      if (result.success) {
        this.project = result.project;
        this.text_image = this.project.text_image;
        this.text_title = this.project.text_title;
        this.field_names = this.project.field_names;

        if (this.question == "") {
          this.question = this.project.guiding_question;
        }
      } else {
        this.not_found = true;
      }
    },
    async logAction(user_id, activity, json_data) {
      let messagebody = null

      if (json_data) {
        messagebody = JSON.stringify({user_id: user_id, activity: activity, json_data: json_data});
      } else {
        messagebody = JSON.stringify({user_id: user_id, activity: activity});
      }

      // console.log(messagebody);

      const res = await fetch('api/logactivity/', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: messagebody
      });

      let result = (await res.json());

      if (result.success) {
        console.log("success");
      }
    },
    logError(obj) {
      this.logAction(localStorage.getItem('user_id'), "Error", obj);
    },
    eventNameChange(obj) {
      this.logAction(localStorage.getItem('user_id'), "Edit Event Name", obj);
    },
    toTimeline() {
      this.text = false;
      this.logAction(localStorage.getItem('user_id'), "Pressed To Timeline", null);
    },
    toText() {
      this.text = true;
      this.logAction(localStorage.getItem('user_id'), "Pressed To Text", null);
    },
    addEventBlock(newEventBlock) {
      const newEvent={
        name: newEventBlock.name,
        startDate: newEventBlock.startDate,
        endDate: newEventBlock.endDate,
        durationNumber: newEventBlock.durationNumber,
        durationType: newEventBlock.durationType,
        extra_fields: newEventBlock.extra_fields,
        id: newEventBlock.id,
        counter: 0
      }

      this.event_items = [...this.event_items, newEvent];

      this.$nextTick(() => {
        document.getElementById(newEvent.id).scrollIntoView();
      });

      this.logAction(localStorage.getItem('user_id'), "Created Event", JSON.stringify(newEvent));
    },
    dateChange(obj) {
      this.logAction(localStorage.getItem('user_id'), "Edited Event Date", JSON.stringify({event_id: obj.id, date_portion_changed: obj.changed, new_val: obj.newVal}));

      let eventIndex = this.event_items.map(a => a.id).indexOf(obj.id);

      if (obj.changed == 'startyear') {
        this.event_items[eventIndex].startDate.setFullYear(obj.newVal);
        this.event_items[eventIndex].durationNumber = null;
        this.event_items[eventIndex].durationType = null;
        this.event_items[eventIndex].counter += 1;
      }

      if (obj.changed == 'startmonth') {
        this.event_items[eventIndex].startDate.setMonth(obj.newVal);
        this.event_items[eventIndex].durationNumber = null;
        this.event_items[eventIndex].durationType = null;
        this.event_items[eventIndex].counter += 1;
      }

      if (obj.changed == 'startday') {
        this.event_items[eventIndex].startDate.setDate(obj.newVal);
        this.event_items[eventIndex].durationNumber = null;
        this.event_items[eventIndex].durationType = null;
        this.event_items[eventIndex].counter += 1;
      }

      if (obj.changed == 'endyear') {
        this.event_items[eventIndex].endDate.setFullYear(obj.newVal);
        this.event_items[eventIndex].durationNumber = null;
        this.event_items[eventIndex].durationType = null;
        this.event_items[eventIndex].counter += 1;
      }

      if (obj.changed == 'endmonth') {
        this.event_items[eventIndex].endDate.setMonth(obj.newVal);
        this.event_items[eventIndex].durationNumber = null;
        this.event_items[eventIndex].durationType = null;
        this.event_items[eventIndex].counter += 1;
      }

      if (obj.changed == 'endday') {
        this.event_items[eventIndex].endDate.setDate(obj.newVal);
        this.event_items[eventIndex].durationNumber = null;
        this.event_items[eventIndex].durationType = null;
        this.event_items[eventIndex].counter += 1;
      }

      if (obj.changed == 'dn') {
        this.event_items[eventIndex].durationNumber = obj.newVal;

        if (this.event_items[eventIndex].durationType == 0) {
          let days = obj.newVal;

          if ((obj.newVal - 1) >= 0) {
            days = obj.newVal - 1;
          }

          this.event_items[eventIndex].endDate = new Date(this.event_items[eventIndex].startDate.getFullYear(), this.event_items[eventIndex].startDate.getMonth(), (this.event_items[eventIndex].startDate.getDate() + days));
        }

        if (this.event_items[eventIndex].durationType == 1) {
          this.event_items[eventIndex].endDate = new Date(this.event_items[eventIndex].startDate.getFullYear(), (this.event_items[eventIndex].startDate.getMonth() + obj.newVal), this.event_items[eventIndex].startDate.getDate());
        }

        if (this.event_items[eventIndex].durationType == 2) {
          this.event_items[eventIndex].endDate = new Date((this.event_items[eventIndex].startDate.getFullYear() + obj.newVal), this.event_items[eventIndex].startDate.getMonth(), this.event_items[eventIndex].startDate.getDate());
        }
      }

      if (obj.changed == 'dt') {
        this.event_items[eventIndex].durationType = obj.newVal;

        if (this.event_items[eventIndex].durationNumber) {
          if (obj.newVal == 0) {
            let days = this.event_items[eventIndex].durationNumber;
            if ((this.event_items[eventIndex].durationNumber - 1) >= 0) {
              days = this.event_items[eventIndex].durationNumber - 1;
            }

            this.event_items[eventIndex].endDate = new Date(this.event_items[eventIndex].startDate.getFullYear(), this.event_items[eventIndex].startDate.getMonth(), (this.event_items[eventIndex].startDate.getDate() + days));
          }

          if (obj.newVal == 1) {
            this.event_items[eventIndex].endDate = new Date(this.event_items[eventIndex].startDate.getFullYear(), (this.event_items[eventIndex].startDate.getMonth() + this.event_items[eventIndex].durationNumber), this.event_items[eventIndex].startDate.getDate());
          }

          if (obj.newVal == 2) {
            this.event_items[eventIndex].endDate = new Date((this.event_items[eventIndex].startDate.getFullYear() + this.event_items[eventIndex].durationNumber), this.event_items[eventIndex].startDate.getMonth(), this.event_items[eventIndex].startDate.getDate());
          }
        }
      }
    },
    deleteEvent(id) {
      this.logAction(localStorage.getItem('user_id'), "Delete event", JSON.stringify(this.event_items.filter(a => (a.id == id))));
      this.event_items = this.event_items.filter(a => (a.id != id));
    }
  },
  created () {
    this.getProject(this.$route.params.id);

    if (localStorage.getItem('user_id')) {
      // log start activity
      this.logAction(localStorage.getItem('user_id'), "Create session", JSON.stringify({project_id: this.$route.params.id}));
    } else {
      // new user id
      let userid = crypto.randomUUID();

      // store in localStorage
      localStorage.setItem('user_id', userid);

      // log start activity
      this.logAction(localStorage.getItem('user_id'), "Create session", JSON.stringify({project_id: this.$route.params.id}));
    }
  },
  mounted () {
    if (localStorage.getItem(('event_items' + this.$route.params.id))) {
      this.event_items = JSON.parse(localStorage.getItem(('event_items' + this.$route.params.id)), function(k, v) {
        if (k == "startDate" || k == "endDate") {
          return new Date(v);
        } else {
          return v;
        }
      });
      this.componentKey += 1;
    }

    if (localStorage.getItem(('question' + this.$route.params.id))) {
      this.question = localStorage.getItem(('question' + this.$route.params.id));
    }
  },
  watch: {
    event_items: {
      handler () {
        this.componentKey += 1;
        localStorage.setItem(('event_items' + this.$route.params.id), JSON.stringify(this.event_items));
      },
      deep: true,
    },
    question: {
      handler () {
        localStorage.setItem(('question' + this.$route.params.id), this.question);
        this.logAction(localStorage.getItem('user_id'), "Edited guiding question text", JSON.stringify({new_question: this.question}));
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr 1fr 1.5fr repeat(auto-fill , 1fr) 1.5fr 1fr;
  grid-auto-rows: minmax(0, auto);
  gap: 0.5rem;
  min-height: 0;
  min-width: 0;
  width: 100vw;
  height: 100vh;

}

.question-display {
  grid-area: 1 / 3 / 1 / 7;
}

.add-event {
  grid-area: 1 / 1 / 3 / 3;
  overflow-y: scroll;
  overflow-x: auto;
  display: inline-block;


}
.add-event::-webkit-scrollbar {
      width: 15px;
}

.add-event::-webkit-scrollbar-track {
    background-color: var(--background-gray);
}

.add-event::-webkit-scrollbar-thumb {
    background: var(--block-orange);
    border-radius: 25px;
    border: fill;
    border-color: black;
}

.event-blocks {
  grid-area: 3 / 1 / 5 / 3;
  height: 100%;
  background-color: var(--background-gray);
  background-size: cover;
  overflow-y: scroll;
  overflow-x: auto;
  width: 100%;
}

.event-blocks::-webkit-scrollbar {
      width: 15px;
}

.event-blocks::-webkit-scrollbar-track {
    background-color: var(--background-gray);
}

.event-blocks::-webkit-scrollbar-thumb {
    background: var(--form-blue);
    border-radius: 25px;
}


.question {
  grid-area: 5 / 1 / 7 / 3;
}

.to-text {
  grid-area: 5 / 3 / 5 / 4;

}

.to-timeline {
  grid-area: 5 / 6 / 5 / 7;
}

.content {
  grid-area: 2 / 3 / 5 / 7;
  width: 100%;
}

.button {
  border: none;
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 500;
  border-radius: 2px;
}

.button:hover{
  cursor: pointer;
}

.question{
  font-weight: 500;
}

.question input::placeholder{
  font-weight: 500;
  font-style: italic;
}

.question input{
  width: 100%;
  height: 25px;
}
.question-display h3{
  height: 50px;

}
.question label{
  font-size: 20px;
}
</style>
